export default __webpack_public_path__ + "static/blaz-32b9a4198198cad2f3a1103133406c1d.svg";